module.exports = __webpack_public_path__ + "assets/img/txt-mv.792891d4.svg";